import type { SVGProps } from "react";

export function IconGrayThree(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F7F8FE" />
      <path
        d="M22.1414 32.68H24.9014C25.2374 33.976 26.4134 34.888 27.9734 34.888C29.7014 34.888 30.9254 33.76 30.9254 32.176C30.9254 30.448 29.5574 29.536 28.0454 29.536H26.7734V27.4H27.9494C29.4374 27.4 30.6374 26.464 30.6374 24.904C30.6374 23.536 29.6294 22.552 28.0934 22.552C26.6534 22.552 25.5734 23.344 25.2134 24.688H22.4294C22.9814 22.096 24.9974 20.176 28.2134 20.176C31.3094 20.176 33.3974 22.024 33.3974 24.544C33.3974 26.344 32.3174 27.64 30.8054 28.336C32.5334 28.984 33.7574 30.328 33.7574 32.392C33.7574 35.32 31.3334 37.264 28.0214 37.264C24.6854 37.264 22.5974 35.32 22.1414 32.68Z"
        fill="#1C1719"
      />
    </svg>
  );
}
